<template>
  <!-- The classic block's state, sounds and routing; only the popups are v5 -->
  <MatchmakingBlock :lobby-route-name="lobbyRouteName">
    <template #found="{ lobby }"><V5MatchFound :lobby="lobby" /></template>
    <template #invite="{ invite }"><V5PartyInvite :key="invite.id" :invite="invite" /></template>
    <template #offer><V5SeatOffer /></template>
  </MatchmakingBlock>
</template>

<script setup>
import MatchmakingBlock from '../../components/Matchmaking/MatchmakingBlock.vue';
import V5MatchFound from './V5MatchFound.vue';
import V5PartyInvite from './V5PartyInvite.vue';
import V5SeatOffer from './V5SeatOffer.vue';

defineProps({
  lobbyRouteName: { type: String, default: undefined },
});
</script>
